import { ProTable, ProColumns, ProCoreActionType } from '@ant-design/pro-components';
import type { ExpandableConfig } from 'antd/es/table/interface';
import { useEffect, useRef, useState } from 'react';

export interface Prop {
  loading: boolean;
  tableTitle: string;
  columns: ProColumns<any>[];
  dataSource: any[];
  className?: string;
  rowKey?: string;
  expandable?: ExpandableConfig<any>;
  onCilickRow?: (record: any) => void;
  tableChildren?: React.ReactNode;
}

export default function PrintContent({
  loading,
  tableTitle,
  columns,
  dataSource,
  onCilickRow,
  className,
  rowKey = 'id',
  tableChildren,
  expandable,
}: Prop) {
  const [refreshKey, setRefreshKey] = useState<number>();
  const tableRef = useRef<ProCoreActionType>(null);
  useEffect(() => {
    setRefreshKey(Math.random());
  }, [dataSource, rowKey]);

  return (
    <>
      <div className="text-center py-4">
        <h2 className="text-[20px] font-medium">{tableTitle}</h2>
      </div>
      {tableChildren}
      <ProTable
        search={false}
        key={refreshKey}
        columns={columns}
        options={false}
        actionRef={tableRef}
        rowKey={rowKey}
        loading={loading}
        rowHoverable
        scroll={{ x: 'max-content' }}
        dataSource={dataSource}
        columnEmptyText=" "
        className={className}
        pagination={false}
        expandable={expandable}
        onRow={(record) => {
          return {
            onClick: () => {
              onCilickRow?.(record);
            },
          };
        }}
      />
    </>
  );
}
